import React, { Component, Fragment } from 'react';
import { Menu, Badge, Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from 'actions';

import './SpellsSetup.css';

const mapStateToProps = state => ({
	decos: state.spell.decos,
});

const mapDispatchToProps = dispatch => ({
	//onSpellDeco: decos => dispatch(actions.onSpellDeco(decos)),
	onSpellSearchFilter: searchFilter => dispatch(actions.onSpellSearchFilter(searchFilter)),
	onSelectedItem: selectedItem => dispatch(actions.onSelectedItem(selectedItem)),
});

const initialData = decos => {
	let count = 0;
	const keys = Object.keys(decos);
	count = keys.length;
	let spaceCount = 0,
		standardCount = 0,
		spellCount = 0,
		specialCharCount = 0,
		wordSelectCount = 0,
		etcCount = 0;
	const spaceData = Object.values(decos).filter(a => a.helpcate.SPACE === 1);
	const standard = Object.values(decos).filter(a => a.helpcate.STANDARD === 1);
	const spellData = Object.values(decos).filter(a => a.helpcate.SPELL === 1);
	const specialChar = Object.values(decos).filter(a => a.helpcate.SPECIAL_CHAR === 1);
	const wordSelect = Object.values(decos).filter(a => a.helpcate.WORD_SELECT === 1);
	const etc = Object.values(decos).filter(
		a =>
			a.helpcate.SPACE !== 1 &&
			a.helpcate.STANDARD !== 1 &&
			a.helpcate.SPELL !== 1 &&
			a.helpcate.SPECIAL_CHAR !== 1 &&
			a.helpcate.WORD_SELECT !== 1
	);
	spaceCount = spaceData.length;
	standardCount = standard.length;
	spellCount = spellData.length;
	specialCharCount = specialChar.length;
	wordSelectCount = wordSelect.length;
	etcCount = etc.length;

	return { count, spaceCount, standardCount, spellCount, specialCharCount, wordSelectCount, etcCount };
};

class SpellsSetup extends Component {
	constructor(props) {
		super(props);

		const datas = initialData(props.decos);

		this.state = {
			...datas,
		};
	}

	getTitle = helpcate => {
		switch (helpcate) {
			case 'ALL':
				return '전체';
			case 'SPACE':
				return '띄어쓰기 오류';
			case 'STANDARD':
				return '표준어 오류';
			case 'SPELL':
				return '철자 오류';
			case 'SPECIAL_CHAR':
				return '문장 부호 오류';
			case 'WORD_SELECT':
				return '어휘 선택 오류';
			case 'ETC':
				return '기타 오류';
			default:
				return '';
		}
	};

	componentWillReceiveProps(nextProps) {
		const datas = initialData(nextProps.decos);
		this.setState({
			...datas,
		});
	}

	onClickDecos = (e, helpcate) => {
		//const { decos } = this.props;
		this.props.onSpellSearchFilter(helpcate);
		this.props.onSelectedItem(null);
		let pathname = '';
		if (this.props.location.pathname.indexOf('/decoinfo') > -1) {
			pathname = this.props.location.pathname;
		} else {
			pathname = this.props.match.url + '/decos/decoinfo';
		}
		this.props.history.push({
			pathname: pathname,
			post: {
				title: this.getTitle(helpcate),
				//		helpcate,
			},
		});
	};

	render() {
		const {
			count,
			spaceCount,
			standardCount,
			spellCount,
			specialCharCount,
			wordSelectCount,
			etcCount,
		} = this.state;

		return (
			<Fragment>
				<div
					style={{
						padding: '8px 10px',
						margin: '0',
						background: '#fff',
					}}
				>
					<Menu>
						<Menu.Item key="menu1" onClick={e => this.onClickDecos(e, 'ALL')} style={{ margin: 0 }}>
							<Row type="flex" justify="space-between">
								<Col>전체보기</Col>
								<Col>
									<Badge count={count} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
						<Menu.Item key="menu2" onClick={e => this.onClickDecos(e, 'SPACE')} style={{ margin: 0 }}>
							<Row type="flex" justify="space-between">
								<Col>띄어쓰기 오류</Col>
								<Col>
									<Badge count={spaceCount} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
						<Menu.Item key="menu3" onClick={e => this.onClickDecos(e, 'STANDARD')} style={{ margin: 0 }}>
							<Row type="flex" justify="space-between">
								<Col>표준어 오류</Col>
								<Col>
									<Badge count={standardCount} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
						<Menu.Item key="menu4" onClick={e => this.onClickDecos(e, 'SPELL')} style={{ margin: 0 }}>
							<Row type="flex" justify="space-between">
								<Col>철자 오류</Col>
								<Col>
									<Badge count={spellCount} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
						<Menu.Item
							key="menu5"
							onClick={e => this.onClickDecos(e, 'SPECIAL_CHAR')}
							style={{ margin: 0 }}
						>
							<Row type="flex" justify="space-between">
								<Col>문장 부호 오류</Col>
								<Col>
									<Badge count={specialCharCount} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
						<Menu.Item key="menu6" onClick={e => this.onClickDecos(e, 'WORD_SELECT')} style={{ margin: 0 }}>
							<Row type="flex" justify="space-between">
								<Col>어휘 선택 오류</Col>
								<Col>
									<Badge count={wordSelectCount} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
						<Menu.Item key="menu7" onClick={e => this.onClickDecos(e, 'ETC')} style={{ margin: 0 }}>
							<Row type="flex" justify="space-between">
								<Col>기타 오류</Col>
								<Col>
									<Badge count={etcCount} overflowCount={999} />
								</Col>
							</Row>
						</Menu.Item>
					</Menu>
				</div>
			</Fragment>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SpellsSetup));
